// medplum-reception.js — ONLINE-PRIMARY, same recipe as medplum-queue.js.
// Reception is the front desk's whole-clinic board. It reads as the ONE
// logged-in Medplum session (getMedplum()) — the front desk sees the whole
// clinic because the opd-receptionist AccessPolicy has no department
// criterion (unlike the doctor's opd-doctor-rowlevel), i.e. the breadth comes
// from RLS on the user's own token, not from a separate demo identity. A
// non-front-desk login never reaches this loader (App.jsx role gate). Same
// shapeQueueRow DTO as queue.jsx — Reception.jsx reads
// reception.rows/reception.date, unchanged.
import { getMedplum, deriveCurrentUser } from './client-port.js';
import { buildDateRangeFilter, loadEncounterWorklistBundle } from './medplum-bounded-search.js';
import { clinicTodayKey, clinicDayBounds } from '@healther/clinical-core/clinic-time.js';
import { shapeQueueRow, groupEncounterBundle } from '@healther/clinical-core/shape/queue-row.js';

export async function loadReceptionFromMedplum() {
  const { medplum, hospital } = await getMedplum();

  // Clinic-local "today" — SAME clinicTodayKey()/clinicDayBounds() helper
  // Schedule.jsx and Reception.jsx's own date-picker (todayIsoDate()) already key
  // off (clinic-time.js). A raw `new Date().toISOString().slice(0,10)` UTC date
  // slice disagreed with those for the ~00:00-05:30 IST window each night (UTC
  // is still on yesterday's calendar date while the clinic is already into
  // today), so Reception's "Today" tab could show yesterday's list past IST
  // midnight even though its own date picker already thought it was "today".
  const today = clinicTodayKey();
  const { start, end } = clinicDayBounds(today);
  const baseQuery = `date=ge${start}&date=lt${end}&_include=Encounter:subject&_revinclude=Composition:encounter`;
  const { bundle, truncated, fetchedCount, maxRows } = await loadEncounterWorklistBundle(medplum, {
    baseQuery,
    dateFilterArg: buildDateRangeFilter(start, end, 'lt'),
  });

  const { patients, compsByEnc, encs } = groupEncounterBundle(bundle);
  const rows = encs.map((enc) => shapeQueueRow(enc, patients[enc.subject && enc.subject.reference] || null, compsByEnc['Encounter/' + enc.id] || []));

  return {
    source: 'medplum-client-shaping',
    truncated,
    fetchedCount,
    maxRows,
    reception: { rows, date: today },
    currentUser: await deriveCurrentUser(medplum),
    hospital,
  };
}
